import { createContext, useContext } from 'react';

export const ResponsiveFormContext = createContext<boolean>(false);

export function useResponsiveFormContext() {
  return useContext(ResponsiveFormContext);
}
